import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { CheckOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';
import { dialogFunction } from 'common/components/index';

import { useDispatchReloadPage } from 'hooks/useReloadPage';
import { useInvalidateAllGDSNProducts } from 'pages/publication/hooks';

import * as productServices from 'services/product';
import { apiHandler } from 'utils/api';
import gridSelectors from 'common/components/grid-view/controllers/selectors';

import Messages from 'i18n/messages/home';

const AcceptPublication = (props) => {
  const reloadPage = useDispatchReloadPage();

  const invalidateAllGDSNReceivedProducts = useInvalidateAllGDSNProducts();

  const gridSelections = useSelector(
    gridSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const intl = useIntl();

  const { onRefetchNavigationMenu, onClearItemGrid } = props;

  const onClickBtn = () => {
    dialogFunction({
      type: 'info',
      content: intl.formatMessage(Messages.acceptPublicationConfirm),
      okText: intl.formatMessage(Messages.acceptPublicationConfirmYes),
      cancelText: intl.formatMessage(Messages.acceptPublicationConfirmNo),
      onOk: callApiAcceptPublication,
    });
  };

  const callApiAcceptPublication = () => {
    const idList = gridSelections.map((item) => item?.id);

    const params = {
      ids: idList,
    };

    const successMessage = intl.formatMessage(
      Messages.acceptPublicationSuccess
    );
    const errorMessage = intl.formatMessage(Messages.acceptPublicationError);

    apiHandler({
      service: productServices.acceptPublication,
      params,
      successMessage,
      errorMessage,
      successCallback,
    });
  };
  const successCallback = () => {
    reloadPage();
    onRefetchNavigationMenu();
    invalidateAllGDSNReceivedProducts();
    onClearItemGrid();
  };

  const checkDisabled = () => {
    if (!gridSelections?.length) return true;

    return gridSelections.some(
      (item) => item?.status?.toLowerCase() !== 'pending'
    );
  };

  return (
    <RibbonButton
      icon={<CheckOutlined />}
      label={Messages.acceptSubscription}
      onClick={onClickBtn}
      disabled={checkDisabled()}
    />
  );
};

export default AcceptPublication;
